<template>
    <div class="pt-4">
        
        <table class="table is-fullwidth is-bordered is-hoverable">
            <thead>
                <tr>
                    <th class="has-text-centered has-text-weight-normal">{{ $t('Sessions.player-name') }}</th>
                    <th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.score') }}
                    </th>
                    <th class="has-text-centered has-text-weight-normal">{{ $t('Sessions.time') }}</th>
                    <!--<th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.hit_rate') }}
                    </th>-->
                    <th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.mean_time') }}
                    </th>
                    <th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.last_played_date') }}
                    </th>
                    <!--<th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.device') }}
                    </th>-->
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="player in filteredRanking"
                    :key="player.owner._id"
                    :class="{ unplayed: !hasplayed(player) }"
                    class="player-data"
                    @click="showPlayerStats(player)"
                >
                    <td class="">
                        <div class="columns is-mobile">
                            <div class="column is-narrow position-number has-background-eduloc-blue">
                                <p class="is-size-5 has-text-white px-1 py-1">{{userPosition(player)}}</p>
                            </div>
                            <div class="column userName">
                                <!--<user-mini-profile :user="player" :show-school="true" />-->
                                <p class="px-1 py-1 secondary-font-bold is-size-6">{{ player.alias || player.name }}</p>
                                <!--<p v-if="player.school">{{ player.school.name }}</p>-->
                            </div>
                        </div>
                    </td>
                    <td class="primary-font is-size-5 has-text-eduloc-red has-text-centered is-vcentered">
                        <span v-html="hasplayed(player) ? player.score : '-'" />
                    </td>
                    <td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.totalTime(player.time)
                                    : '-'
                            "
                        />
                    </td>
                    <!--<td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerHitRate(player)+'%'
                                    : '-'
                            "
                        />
                    </td>-->
                    <td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerMeanTime(player)
                                    : '-'
                            "
                        />
                    </td>
                    <td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerPlayDate(
                                          player.timesPlayed
                                      )
                                    : '-'
                            "
                        />
                    </td>
                    <!--<td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="hasplayed(player) ? player.device : '-'"
                        />
                    </td>-->
                </tr>
            </tbody>
        </table>

        <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1100"
            :pdf-content-width="'100%'"
            :filename="player.alias ? player.alias : player.username"
            :pdf-quality="2"
            :manual-pagination="true"
            ref="html2Pdf"
            :htmlToPdfOptions="{
                margin: 20,
                jsPDF: {
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4',
                    putOnlyUsedFonts: 'false',
                    compress: 'false',
                    precision: '20',
                    filename: player.alias ? player.alias : player.username,
                },
            }"
        >
            <section slot="pdf-content">

                <table class="table is-fullwidth is-bordered is-hoverable">
            <thead>
                <tr class="">
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">{{ $t('Sessions.player-name') }}</th>
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">
                        {{ $t('Sessions.score') }}
                    </th>
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">{{ $t('Sessions.time') }}</th>
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">
                        {{ $t('Sessions.hit_rate') }}
                    </th>
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">
                        {{ $t('Sessions.mean_time') }}
                    </th>
                    <th class="has-text-centered has-text-weight-bold pt-2 pb-4" style="vertical-align: middle;">
                        {{ $t('Sessions.last_played_date') }}
                    </th>
                    <!--<th class="has-text-centered has-text-weight-normal">
                        {{ $t('Sessions.device') }}
                    </th>-->
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="player in filteredRanking"
                    :key="player.owner._id"
                    :class="{ unplayed: !hasplayed(player) }"
                    class=""
                >
                    <td class=" pt-2 pb-4">
                        <div class="columns is-mobile">
                            <div class="column is-narrow position-number has-background-eduloc-blue">
                                <p class="is-size-5 has-text-white px-1 py-1">{{userPosition(player)}}</p>
                            </div>
                            <div class="column userName">
                                <!--<user-mini-profile :user="player" :show-school="true" />-->
                                <p class="px-1 py-1 secondary-font-bold is-size-6">{{ player.alias || player.name }}</p>
                                <!--<p v-if="player.school">{{ player.school.name }}</p>-->
                            </div>
                        </div>
                    </td>
                    <td class="primary-font is-size-5 has-text-eduloc-red has-text-centered is-vcentered  pt-2 pb-4">
                        <span v-html="hasplayed(player) ? player.score : '-'" />
                    </td>
                    <td class="secondary-font has-text-centered is-vcentered  pt-2 pb-4 ">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.totalTime(player.time)
                                    : '-'
                            "
                        />
                    </td>
                    <!--<td class="secondary-font has-text-centered is-vcentered pt-2 pb-4">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerHitRate(player)+'%'
                                    : '-'
                            "
                        />
                    </td>-->
                    <td class="secondary-font has-text-centered is-vcentered pt-2 pb-4 ">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerMeanTime(player)
                                    : '-'
                            "
                        />
                    </td>
                    <td class="secondary-font has-text-centered is-vcentered pt-2 pb-4">
                        <span
                            v-html="
                                hasplayed(player)
                                    ? $options.filters.playerPlayDate(
                                          player.timesPlayed
                                      )
                                    : '-'
                            "
                        />
                    </td>
                    <!--<td class="secondary-font has-text-centered is-vcentered">
                        <span
                            v-html="hasplayed(player) ? player.device : '-'"
                        />
                    </td>-->
                </tr>
            </tbody>
        </table>

            </section>
        </VueHtml2pdf>



        <session-detail-player
            v-if="showPlayerDetails"
            :player="player"
            :report-info="reportInfo"
            :cluesCount="clues.length"
            :questionsCount="questions.length"
            @close="showPlayerDetails = false"
        />
    </div>
</template>

<script>
import UserMiniProfile from '@/components/UserMiniProfile';
import SessionDetailPlayer from '@/components/SessionDetailPlayer';

import { groupBy, reduce, findWhere, map, sortBy } from 'underscore';
import { getSessionRankingStatistics } from '@/services/API';
import { timeFormat } from '@/lib/helpers';
import moment from 'moment';
import { Document } from 'flexsearch';
import _ from 'underscore';
import VueHtml2pdf from 'vue-html2pdf';
export default {
    name: 'SessionDetailPlayers',
    components: {
        UserMiniProfile,
        SessionDetailPlayer,
        VueHtml2pdf
    },
    filters: {
        playerHitRate(player) {
            // console.log("player data",player)
            if (player.answersCount)
                return (
                    (player.score / player.answersCount / 10) *
                    100
                ).toFixed(0);
            else {
                return 0;
            }
        },
        playerMeanTime(player) {
            return timeFormat(player.meanTime || 0) + ' min';
        },
        totalTime(time) {
            return timeFormat(+time) + ' min';
        },
        playerPlayDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    props: {
        questions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        clues: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isTreasurehunt: {
            type: Boolean,
            default: false,
        },
        /*userAnswers: {
            type: Array,
            default: () => {
                return [];
            },
        },*/
        content: {
            type: Array,
            default: () => {
                return [];
            },
        },
        reportInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
        searchValue: {
            type: String,
            default: ""
        },
        generatePdf: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            ranking: {},
            searchIndex: null,
            player: {},
            showPlayerDetails: false,
            position: null,
        };
    },
    computed: {
        uniquePlayers() {
            let players = groupBy(this.scores, (score) => {
                return score.owner.owner;
            });
            let ranking = map(players, (scores, player) => {
                return {
                    name: scores[0].owner.name,
                    owner: scores[0].owner.owner,
                    score: reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.points;
                        },
                        0
                    ),
                    time: reduce(
                        scores,
                        (memo, score) => {
                            return memo + score.time;
                        },
                        0
                    ),
                };
            });
            return sortBy(ranking, 'totalScore').reverse();
        },
        filteredRanking() {
            if (this.searchValue) {
                let items;
                items = this.ranking;
                this.searchIndex.remove(this.ranking);
                this.searchIndex.add(items);
                const result = this.searchIndex.search(this.searchValue);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.ranking.filter((item) => {
                    return _.contains(ids, item._id);
                });

                //return this.searchIndex.search(this.searchValue);
            }
            return this.ranking;
        },
    },
    mounted() {
        getSessionRankingStatistics(this.$route.params._id).then(({ data }) => {
            this.ranking = data;
            // console.log(data)
        });
        // console.log("clues lenght",this.clues.length)
    },
    methods: {
        userPosition(player){
            if(player.position.toString().length<2){
                return '0'+player.position.toString();
            }
            return player.position.toString();
        },
        hasplayed(player) {
            return player.time != '0';
        },
        showPlayerStats(player) {
            let playerData = { ...player };
            playerData.position = this.ranking.indexOf(player) + 1;
            playerData.playedDate = this.$options.filters.playerPlayDate(
                playerData.timesPlayed
            );
            playerData.hitRate = Number(
                this.$options.filters.playerHitRate(playerData)
            );
            playerData.score = Number(playerData.score);
            playerData.gameTime = this.$options.filters.totalTime(
                playerData.time
            );
            playerData.meanTime =
                this.$options.filters.playerMeanTime(playerData);

            // console.log("player clues", this.clues)
            // console.log("player content", this.content)
            playerData.clues = [...this.clues];
            playerData.questions = [...this.questions];
            this.player = playerData;
            this.showPlayerDetails = true;
        },
        /*() {
            //this.showingProgress = true;
            this.$refs.html2Pdf.generatePdf();
        },*/
    },
    beforeMount() {
        this.searchIndex = new Document({
            resolution: 3,
            tokenize: 'full',
            document: {
                id: '_id',
                index: ['alias', 'username', 'school.name'],
            },
        });
    },
    watch: {
        ranking() {
            this.ranking.forEach((item) => {
                this.searchIndex.add(item);
            });
        },
        generatePdf() {
            if(this.generatePdf){
                this.$refs.html2Pdf.generatePdf();
                this.$emit("pdfGenerated")
            }
        },
    },
};
</script>

<style scooped>
.lb-mini-profile-title {
    color: #4a4a4a !important;
}
.lb-project-search-bar {
    background-color: transparent;
    border: none;
    max-width: 100px;
}
.lb-project-search-bar .icon {
    color: #4a4a4a !important;
}
.lb-project-search-bar input {
    color: #4a4a4a !important;
}
::-webkit-input-placeholder {
    /* Chrome */
    color: #4a4a4a !important;
}
:-ms-input-placeholder {
    /* IE 10+ */
    color: #4a4a4a !important;
}
::-moz-placeholder {
    /* Firefox 19+ */
    color: #4a4a4a !important;
    opacity: 1;
}
:-moz-placeholder {
    /* Firefox 4 - 18 */
    color: #4a4a4a !important;
    opacity: 1;
}
.unplayed {
    display: none;
}
.player-data {
    cursor: pointer;
}
.position-number{
    min-width: 4rem;
    text-align: center;
}
</style>
